import { useEffect, useRef } from 'react';
import { ErrorBoundaryErrorType } from 'contexts/ErrorBoundaryContext/ErrorBoundaryContext';

export const useResetErrorBoundaryOnLocationChange = (
    error: ErrorBoundaryErrorType | undefined,
    setError: (error: ErrorBoundaryErrorType | undefined) => void,
) => {
    const locationRef = useRef(document.location.href);

    if (error && locationRef.current !== document.location.href) {
        locationRef.current = document.location.href;
        setError(undefined);
    }
};

export const useDisableSpacebarScrolling = () => {
    const onSpacebarKeydown = (e: KeyboardEvent) => {
        const { key, isComposing, target } = e;
        const isSpacebar = key === 'Spacebar' || key === ' ';
        const isTargettingBody = target === document.body;

        if (isComposing || !isSpacebar || !isTargettingBody) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
    };

    useEffect(() => {
        window.addEventListener('keydown', onSpacebarKeydown);

        return () => window.removeEventListener('keydown', onSpacebarKeydown);
    }, []);
};
